import { DonorError } from './errors';

/** Credential policy is chosen by the client, never inferred from browser session state. */
export async function requestJson(url: string, options: RequestInit): Promise<unknown> {
  const controller = new AbortController();
  const abort = (): void => controller.abort();
  if (options.signal?.aborted) abort();
  options.signal?.addEventListener('abort', abort, { once: true });
  const timer = setTimeout(abort, 20_000);
  try {
    const response = await fetch(url, { ...options, signal: controller.signal });
    const payload: unknown =
      response.status === 204 ? undefined : await response.json().catch(() => undefined);
    if (!response.ok) {
      const envelope =
        typeof payload === 'object' && payload !== null && 'error' in payload
          ? payload.error
          : undefined;
      const details =
        typeof envelope === 'object' &&
        envelope !== null &&
        'details' in envelope &&
        typeof envelope.details === 'object' &&
        envelope.details !== null
          ? (envelope.details as Record<string, unknown>)
          : {};
      const code =
        typeof details['code'] === 'string'
          ? details['code']
          : typeof envelope === 'object' &&
              envelope !== null &&
              'code' in envelope &&
              typeof envelope.code === 'string'
            ? envelope.code
            : 'REQUEST_FAILED';
      throw new DonorError(response.status, code, details);
    }
    if (response.status !== 204 && payload === undefined)
      throw new DonorError(0, 'INVALID_API_RESPONSE');
    return payload;
  } catch (error) {
    if (error instanceof DonorError || options.signal?.aborted) throw error;
    throw new DonorError(0, 'NETWORK_UNAVAILABLE');
  } finally {
    clearTimeout(timer);
    options.signal?.removeEventListener('abort', abort);
  }
}
